<section id="signature-config-lot" style="padding: 0px 24px">
  <div class="row pt-4">
    <div class="col-12 table_box">
      <form nz-form>
        <nz-table
          #rowsTable
          nzBordered
          [nzData]="dataFootNote"
          [nzShowPagination]="false"
          [nzFrontPagination]="false"
          class="ant-table-no-placeholder-border-bottom"
        >
          <thead>
            <tr>
              <th class="text-center" nzWidth="55px"></th>
              <th class="text-center" nzWidth="33%">
                {{ "signature_config.name" | translate }}
              </th>
              <th class="text-center" nzWidth="33%">
                {{ "signature_config.choose_subject" | translate }}
              </th>
              <th class="text-center" nzWidth="33%">
                {{ "signature_config.page" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of rowsTable.data; let i = index">
              <td class="text-center">{{ i + 1 }}</td>
<!--              tên chân ký-->
              <td class="text-center">
                {{
                  data.signature && data.signature.name
                    ? data.signature.name
                    : ""
                }}
              </td>

<!--              chọn đối tượng-->
              <td>
                <span
                  class="customer-name"
                  *ngIf="
                    data.signature &&
                    data.signature.object &&
                    data.signature.object === 'ENTERPRISE' &&
                    (!createSide || !userSign) && !this.isHaveDeleteCreata
                  "
                >{{ "signature_tab.create_side" | translate }}</span
                >
                <span
                  class="customer-name"
                  *ngIf="
                    data.signature &&
                    data.signature.object &&
                    data.signature.object === 'ENTERPRISE' &&
                    createSide &&
                    userSign
                  "
                >{{ userSign }}</span
                >
<!--                chỗ này cấu hình chân ký khách hàng-->
                <nz-select
                  nzAllowClear
                  [(ngModel)]="data.customerOrder"
                  [ngModelOptions]="{ standalone: true }"
                  class="td-nz-input"
                  (ngModelChange)="changeSelect($event, i, data.customerOrder)"
                  *ngIf="data.signature &&(!data.signature.object ||data.signature.object === 'CUSTOMER')"
                  [disabled]="disabled"
                >
                  <nz-option *ngFor="let customer of listCustomerOrder"
                    [nzLabel]="customer?.name"
                    [nzValue]="customer?.order"
                  ></nz-option>
                </nz-select>
<!--                chỗ này cấu hình chân ký thằng phê duyệt-->
                <nz-select nzAllowClear [ngModel]="data.userId"
                           [ngModelOptions]="{ standalone: true }"
                           class="td-nz-input"
                           [nzDisabled]="checkDisableApprover(DATA_RECORD_USER_PERFORM_SIGN) || disabled"
                           (ngModelChange)="data.userId = $event;changeSelectApprover($event, data)"
                           *ngIf="data.signature && data.signature.object === 'ENTERPRISEAPPROVER'">
                  <nz-option *ngFor="let option of DATA_RECORD_USER_PERFORM_SIGN"
                             [nzLabel]="option?.name"
                             [nzValue]="option?.userId"
                             [nzHide]="checkDataApprover(option)">
                  </nz-option>
                </nz-select>
                <span
                  class="customer-name"
                  *ngIf="
                    data.signature &&
                    data.signature.object &&
                    data.signature.object === 'ENTERPRISE' &&
                    (!createSide || !userSign) && this.isHaveDeleteCreata
                  ">
                </span>
              </td>
<!--              trang chứa chân ký-->
              <td class="text-center">
                {{
                data.signature && data.signature.page
                  ? data.signature.page
                  : ""
                }}
              </td>
            </tr>
          </tbody>
        </nz-table>
      </form>
    </div>
  </div>
</section>
